module.exports = __webpack_public_path__ + "static/media/ajax-Loader_es.d649a5f6.gif";